import {
	Component,
	IComponentBindings,
	Initialization
} from 'coveo-search-ui';

import * as $ from 'jquery';

export class SearchAssistButton extends Component {
	static ID = 'SearchAssistButton';
	public href: string;

	get isEnabled():boolean {
		return $(this.element).attr("data-enabled") === "true";
	}

	constructor(public element: HTMLElement, public bindings: IComponentBindings) {
		super(element, SearchAssistButton.ID, bindings);
		this.href = this.element.getAttribute("href") + "#";
	}

	public disable() {
		$(this.element).attr("data-enabled", "false");
	}

	public enable() {
		$(this.element).attr("data-enabled", "true");
	}
}

Initialization.registerAutoCreateComponent(SearchAssistButton);



// WEBPACK FOOTER //
// ./src/source/Atlas.SEF.Feature.Common/Areas/AtlasCommon/Assets/Search/components/SearchAssistButton.ts